import { OnInit, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { DomSanitizer } from '@angular/platform-browser';
import { StoryChapterThumbnail } from 'src/app/story/models/story-chapter-thumbnail.model';
import * as _ from 'lodash';
var ChapterCardComponent = /** @class */ (function () {
    function ChapterCardComponent(sanitizer, changeDetection) {
        this.sanitizer = sanitizer;
        this.changeDetection = changeDetection;
        this.canRemove = true;
        this.duplicate = new EventEmitter();
        this.remove = new EventEmitter();
    }
    Object.defineProperty(ChapterCardComponent.prototype, "chapter", {
        get: function () {
            return this._chapter;
        },
        set: function (value) {
            this._chapter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChapterCardComponent.prototype, "thumbnail", {
        get: function () {
            return this._thumbnail;
        },
        set: function (value) {
            this._thumbnail = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChapterCardComponent.prototype, "shortDescription", {
        get: function () {
            var length = 48;
            var description = _.get(this.chapter, 'info.description') || '';
            if (description.length <= length) {
                return description;
            }
            return description
                .replace('<br>', '')
                .substr(0, length - 3) + '...';
        },
        enumerable: true,
        configurable: true
    });
    ChapterCardComponent.prototype.ngOnInit = function () { };
    // return css block for image
    ChapterCardComponent.prototype.getImageStyle = function () {
        // use snapshot if present, otherwise use small
        if (!!this.thumbnail) {
            var url = (this.thumbnail.snapshot) ? this.thumbnail.snapshot : this.thumbnail.urls.small;
            return {
                'background-image': "url(" + url + ")",
                'background-size': 'cover'
            };
        }
        else {
            return {};
        }
    };
    ChapterCardComponent.prototype.handleDuplicateClick = function () {
        this.duplicate.emit(this.chapter);
    };
    ChapterCardComponent.prototype.handleRemoveClick = function () {
        this.remove.emit(this.chapter);
    };
    return ChapterCardComponent;
}());
export { ChapterCardComponent };
